import { permission } from "process";
import { lazy } from "react";

const fleetRoutes = [
  {
    path: "/vehicle-category",
    Component: lazy(() => import("../pages/VehicleCategory")),
    permission: ["vehicle_category:list_all"],
  },
  {
    path: "/vehicle-category/create",
    Component: lazy(() => import("../components/VehicleCategory/CreateEditVehicleCategory")),
    permission: ["vehicle_category:create"],
  },
  {
    path: "/vehicle-category/edit/:id",
    Component: lazy(() => import("../components/VehicleCategory/EditVehicleCategory")),
    permission: ["vehicle_category:update"],
  },
  {
    path: "/vehicle-category/details/:id",
    Component: lazy(() => import("../components/VehicleCategory/DetailVehicleCategory")),
    permission: ["vehicle_category:detail"],
  },

  {
    path: "/vehicle-type",
    Component: lazy(() => import("../pages/VehicleType")),
    permission: ["vehicle_category:list_all"],
  },
  {
    path: "/vehicle-type/create",
    Component: lazy(() => import("../components/VehicleType/CreateEditVehicleType")),
    permission: ["vehicle_category:create"],
  },
  {
    path: "/vehicle-type/edit/:id",
    Component: lazy(() => import("../components/VehicleType/EditVehicleType")),
    permission: ["vehicle_category:update"],
  },
  {
    path: "/vehicle-type/details/:id",
    Component: lazy(() => import("../components/VehicleType/DetailVehicleType")),
    permission: ["vehicle_category:detail"],
  },
  {
    path: "/vehicle/create",
    Component: lazy(() => import("../components/Vehicles/createEdit/CreateVehicles")),
    permission: ["vehicle:create"],
  },
  {
    path: "/vehicle/edit/:id",
    Component: lazy(() => import("../components/Vehicles/createEdit/EditVehicles")),
    permission: ["vehicle:update"],
  },
  {
    path: "/vehicle/details/:id",
    Component: lazy(() => import("../components/Vehicles/details")),
    permission: ["vehicle:detail"],
  },
  {
    path: "/vehicle/subscription-plan/:id",
    Component: lazy(() => import("../components/Vehicles/SubscriptionPlan")),
    permission: ["vehicle:detail"],
  },
  {
    path: "/vehicle",
    Component: lazy(() => import("../pages/Vehicle")),
    permission: ["vehicle:list", "vehicle:list_all"],
  },
  {
    path: "/trip",
    Component: lazy(() => import("../pages/Trips/index")),
    permission: ["trip:list_all", "trip:list"],
  },
  {
    path: "/completed-trip",
    Component: lazy(() => import("../pages/CompletedTrips/index")),
    permission: ["trip:list_all", "trip:list"],
  },
  {
    path: "/trip/create",
    Component: lazy(() => import("../components/Trips/createEdit/createTrip")),
    permission: ["trip:create"],
  },
  {
    path: "/trip/edit/:id",
    Component: lazy(() => import("../components/Trips/edit")),
    permission: ["trip:update"],
  },
  {
    path: "/trip/details/:id",
    Component: lazy(() => import("../components/Trips/details")),
    permission: ["trip:detail"],
  },
  // {
  //   path: "/orders",
  //   Component: lazy(() => import("../pages/OrderAndBids")),
  //   permission: ["bid_request:detail", "bid_request:list_all"],
  // },
  {
    path: "/vehicle-shift-requests",
    Component: lazy(() => import("../pages/VehicleShiftRequests")),
    permission: ["vehicle_shift:list_all"],
  },
  {
    path: "/virtual-checkpoint",
    Component: lazy(() => import("../pages/VirtualCheckpoint")),
    permission: ["*"],
  },
  {
    path: "/virtual-checkpoint/create",
    Component: lazy(() => import("../components/VirtualCheckpoint/CreateEditVirtualCheckpoint")),
    permission: ["*"],
  },
  {
    path: "/virtual-checkpoint/edit/:id",
    Component: lazy(() => import("../components/VirtualCheckpoint/EditVirtualCheckpoint")),
    permission: ["*"],
  },
  {
    path: "/vehicle-shift-requests/details/:id",
    Component: lazy(() => import("../components/VehicleShiftRequests/details/VehicleShiftRequestDetails")),
    permission: ["vehicle_shift:detail"],
  },
  {
    path: "/vehicle/subscription-plan/payment-completed",
    Component: lazy(() => import("../../../core/presentation/pages/PaymentCompleted")),
    permission: ["*"],
  },
  {
    path: "/trip-schedule",
    Component: lazy(() => import("../pages/ScheduleTrip/index")),
    permission: ["trip:list"],
  },
  {
    path: "/payment-report",
    Component: lazy(() => import("../pages/PaymentReport/PaymentReport")),
    permission: ["report:list_all"],
  },
  {
    path: "/payment-commission-report",
    Component: lazy(() => import("../pages/PaymentCommissionReport/PaymentCommisionReport")),
    permission: ["payment_commission:list_all"],
  },
  {
    path: "*",
    Component: lazy(() => import("../../../core/presentation/pages/NotFound")),
    permission: ["*"],
  },
  {
    path: "/subscriptions",
    Component: lazy(() => import("../pages/Subscriptions")),
    permission: ["vehicle:list_all"],
  },
  {
    path: "/shipment-tracking",
    Component: lazy(() => import("../components/OrderAndBids/ShipmentTracking")),
    permission: ["shipment_tracking:list_all"],
  },
  {
    path: "/audit-log-report",
    Component: lazy(() => import("../components/AuditLogs/ListAudit")),
    permission: ["audit_report:list_all"],
  },
  {
    path: "/audit-report/details/:id",
    Component: lazy(() => import("../components/AuditLogs/AuditLogDetails")),
    permission: ["audit_report:detail"],
  },
];

export default fleetRoutes;
